import { tags } from '@/constants/Tags';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';
import { NavigationContext } from '@/shared/NavigationContext/NavigationContext';
import { useRouter } from 'next/router';
import { useContext } from 'react';

export default function useLibraryUtils() {
  const router = useRouter();
  const navigationContext = useContext(NavigationContext);
  const mode =
    navigationContext.state.classes?.length > 0 ? 'addingContent' : 'default';

  const globalContext = useContext(GlobalContext);
  const { isSubscriptionActive, isTeacherPro, isTeacher } = globalContext.state;

  const showAddButtons = isSubscriptionActive && (isTeacherPro || isTeacher);

  const showTaskTemplates =
    isTeacherPro &&
    navigationContext.state.classes.every((clazz) => !clazz.internalUse);

  const currentTagName = getCurrentTagName(navigationContext);
  const isLibrary = router.pathname.includes('library');

  return {
    showAddButtons,
    mode,
    showTaskTemplates,
    allText: currentTagName ? `all ${currentTagName} themes` : 'all themes',
    oneClass: navigationContext.state.classes?.length == 1,
    isLibrary,
    isTeacherPro,
    isTeacher,
  };
}

function getCurrentTagName(navigationContext) {
  const tagId = navigationContext.state.selectedTagId;
  const tagName = tags.find((tag) => tag.id == tagId)?.englishName;
  return tagName || '';
}
